<div class="login-page">

  <!-- Sol Panel: Marka -->
  <div class="login-brand">
    <!-- Desktop Centered Branding -->
    <div class="login-brand__inner">
      <div class="login-brand__logo">
        <img src="/assets/img/logo.svg" [alt]="'giris.anadoluUni' | transloco">
      </div>
      <div class="login-brand__text">
        <div class="login-brand__university">{{ 'giris.anadoluUniUpper' | transloco }}</div>
        <div class="login-brand__title">{{ 'giris.otomasyon' | transloco }}</div>
      </div>
    </div>

    <!-- Mobile Header Branding (Visible < 800px) -->
    <div class="login-mobile-header">
      <div class="login-mobile-header__logo">
        <img src="/assets/img/logo.svg" [alt]="'giris.anadoluUni' | transloco">
      </div>
      <div class="login-mobile-header__text">
        <span class="login-mobile-header__uni">{{ 'giris.anadoluUniUpper' | transloco }}</span>
        <span class="login-mobile-header__sys">{{ 'giris.otomasyon' | transloco }}</span>
      </div>
    </div>
  </div>

  <!-- Global Actions (Floating Top-Right) -->
  <div class="login-actions">
    <div class="login-lang-selector">
      <button class="login-lang-btn" [class.active]="currentLang === 'tr'" (click)="setLang('tr')">TR</button>
      <button class="login-lang-btn" [class.active]="currentLang === 'en'" (click)="setLang('en')">EN</button>
    </div>
  </div>

  <!-- Sağ Panel: Giriş -->
  <div class="login-panel">

    <div class="login-card">

      <!-- İkon -->
      <div class="login-card__icon">
        <i class="fas fa-sign-in-alt"></i>
      </div>

      <!-- Başlık -->
      <h1 class="login-card__heading" [innerHTML]="'giris.hosgeldiniz' | transloco"></h1>

      <!-- Açıklama -->
      <p class="login-card__sub" [innerHTML]="'giris.hosgeldinizAciklama' | transloco"></p>

      <!-- Giriş Seçenekleri -->
      <div class="login-options">
        
        <!-- e-Devlet ile Giriş -->
        <a href="javascript:void(0)" (click)="loginEDevlet()" class="login-option-btn login-option-btn--edevlet">
          <div class="login-option-btn__icon">
            <img src="/assets/img/e-devlet.png" alt="e-Devlet">
          </div>
          <div class="login-option-btn__content">
            <span class="login-option-btn__title">{{ 'giris.loginEDevletTitle' | transloco }}</span>
            <span class="login-option-btn__desc">{{ 'giris.loginEDevletDesc' | transloco }}</span>
          </div>
          <i class="fas fa-chevron-right login-option-btn__arrow"></i>
        </a>

        <!-- Anadolu Üniversitesi Hesabı -->
        <a href="javascript:void(0)" (click)="loginAnadolu()" class="login-option-btn login-option-btn--anadolu">
          <div class="login-option-btn__icon">
            <img src="/assets/img/logo.svg" alt="AÜ" class="au-logo-icon">
          </div>
          <div class="login-option-btn__content">
            <span class="login-option-btn__title">{{ 'giris.loginAuTitle' | transloco }}</span>
            <span class="login-option-btn__desc">{{ 'giris.loginAuDesc' | transloco }}</span>
          </div>
          <i class="fas fa-chevron-right login-option-btn__arrow"></i>
        </a>

        <!-- Yabancı Uyruklu Giriş -->
        <a href="javascript:void(0)" (click)="loginForeign()" class="login-option-btn login-option-btn--foreign">
          <div class="login-option-btn__icon">
            <i class="fas fa-passport"></i>
          </div>
          <div class="login-option-btn__content">
            <span class="login-option-btn__title">{{ 'giris.loginForeignTitle' | transloco }}</span>
            <span class="login-option-btn__desc">{{ 'giris.loginForeignDesc' | transloco }}</span>
          </div>
          <i class="fas fa-chevron-right login-option-btn__arrow"></i>
        </a>

      </div>

    </div>
  </div>

</div>